export const handleGoingUp = () => {
  // scroll to top of page slowly
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export const scroll_to = (id: string) => {
  // scroll to a specific element on the page
  const element = document.getElementById(id);
  if (element) {
    let offset = -100;
    let y = element.getBoundingClientRect().top + window.scrollY + offset;
    // scroll the element into view with an offset
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};
